export const searchChamp = payload => ({
    type: 'SEARCH_CHAMPION',
    payload
});
export const searchChampTag = payload => ({
    type: 'SEARCH_CHAMPION_TAG',
    payload
});
export const getChamp = payload => ({
    type: 'GET_CHAMPION',
    payload
});